import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=0243bdef&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243bdef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0243bdef')) {
      api.createRecord('0243bdef', component.options)
    } else {
      api.reload('0243bdef', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=0243bdef&scoped=true&", function () {
      api.rerender('0243bdef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vH07teKVUaqW/JS/comp/Voucher-Unit.vue"
export default component.exports